module.exports = __webpack_public_path__ + "img/customers.e19b8dec.png";